<template>
  <div class="container_presentation" v-if="course.name">
    <div class="spacer"></div>
    <div class="spacer"></div>
    <b-container>
      <b-row>
        <b-col md="3" class="side_logo_container">
          <img class="side_logo" src="@/assets/img/logo_rectangle_sm.png" alt="Logo challenge maritima" />
        </b-col>
        <b-col md="6">
          <h2 style="font-weight: bold">{{ course.name }} - {{ course.distance }}</h2>
          <h4>{{ course.date }}</h4>
        </b-col>
        <b-col md="3" class="side_logo_container">
          <img class="side_logo" src="@/assets/img/Logo_TotalEnergies.png" alt="Logo Total energies" />
        </b-col>
      </b-row>
      <b-row>
        <b-col offset-md="3" md="6">
          <div class="spacer"></div>
          <!-- <img src="@/assets/img/courses/parcours_castillon.jpg" alt="" />
          <div class="spacer"></div> -->
          <!--  <p>
            Avec son départ et son arrivée sur le site du Théâtre de Verdure voisin de la plage de Ferrières, la Ronde Nocturne des Ponts Bleus vous propose un parcours de 10 km en 2 boucles de 5 km qui vous fera passer par les quais pittoresques des
            3 quartiers de la Venise provençale et par les cinq ponts qui enjambent ses canaux.
          </p>
          <p>Les coureurs s'élanceront en nocturne au moment où le soleil se couchera au-dessus de la passe de Caronte.</p>
          <p>
            La plage de Ferrières sera propice, après course, à des « bains de minuit », et les terrasses des bars et restaurants qui jalonnent le parcours permettront à vos proches de profiter de la douceur de l’été tout en encourageant les
            coureurs.
          </p> -->
        </b-col>
      </b-row>
      <div class="spacer"></div>
      <div class="spacer"></div>
      <b-row>
        <b-col md="4"></b-col>
        <!--  <b-col md="4">
          <img src="@/assets/img/courses/RDPB2023.jpeg" alt="" />
        </b-col> -->
        <b-col md="4">
          <img :src="'https://sportips.fr/VALT23/img/flyer.jpg'" alt="" />
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col>
          <!-- <p><b>Contact : MERVELAY Fabien 06 08 63 33 17</b></p> -->
        </b-col>
      </b-row>
      <div class="spacer"></div>
      <b-row>
        <b-col>
          <!--   <b-button class="infos_btn" download href="https://sportips.fr/challenge-maritima/uploads/COURSE_146491921.gpx" target="_blank">GPX de l'épreuve</b-button>
          <b-button class="infos_btn" href="https://rondedespontsbleus.msathle.com/" target="_blank">Infos course</b-button>
          <b-button class="infos_btn" href="http://rondedespontsbleus.msathle.com/blog/" target="_blank">Réglement</b-button>

          <b-button class="infos_btn" href="https://sportips.fr/" target="_blank">Inscriptions</b-button> -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  props: ["course"],
  created() {},
};
</script>

<style lang="scss" scoped>
</style>